import styled from "styled-components";

// En "Mis ventas" la tabla ancha (con scroll horizontal) se lee mal en celular.
// Para la solapa de solicitudes mostramos tarjetas en pantallas chicas y la
// tabla en pantallas grandes. El corte a 640px es el mismo criterio de mobile
// que usa el resto de la app.

const CORTE = "640px";

// Envoltorios que alternan según el ancho: la tabla solo en desktop, las
// tarjetas solo en mobile. Así no hay que medir el viewport con JS.
export const SoloDesktop = styled.div`
  @media (max-width: ${CORTE}) {
    display: none;
  }
`;

export const SoloMobile = styled.div`
  display: none;

  @media (max-width: ${CORTE}) {
    display: grid;
    gap: 0.6rem;
  }
`;

export const Tarjeta = styled.article`
  background: var(--blanco);
  border-radius: var(--radio);
  box-shadow: var(--sombra);
  padding: 0.85rem 0.95rem;
`;

export const TarjetaHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  gap: 0.75rem;

  strong {
    color: var(--violetaOscuro);
    font-size: 1rem;
    line-height: 1.2;
  }

  time {
    color: var(--grisMedio);
    font-size: 0.78rem;
    white-space: nowrap;
    flex-shrink: 0;
  }
`;

// Etiqueta chiquita arriba de cada dato (reemplaza a la cabecera de la tabla en
// el ancho de un celular). Es su propio componente para no pisar a otros <span>
// dentro de la tarjeta (p. ej. el Badge de estado).
export const Etiqueta = styled.span`
  display: block;
  font-size: 0.7rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.03em;
  color: var(--grisMedio);
  margin-bottom: 0.1rem;
`;

export const Dato = styled.div`
  margin-top: 0.55rem;
  font-size: 0.9rem;
  color: var(--grisOscuro);
  line-height: 1.35;
`;

export const DatosFila = styled.div`
  display: flex;
  gap: 1.25rem;
  flex-wrap: wrap;

  ${Dato} {
    margin-top: 0;
  }
`;

export const MobileVacio = styled.p`
  text-align: center;
  color: var(--grisMedio);
  padding: 1.5rem 0.5rem;
  margin: 0;
`;

// Controles de "Mis ventas": buscador + selector de mes. En celular se apilan.
export const Controles = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 0.6rem;
  align-items: center;
  margin-bottom: 0.75rem;
`;

export const Buscador = styled.input`
  flex: 1 1 220px;
  min-width: 0;
  padding: 0.6rem 0.75rem;
  font-family: inherit;
  font-size: 0.95rem;
  border: 1px solid #d8d2e6;
  border-radius: var(--radio);
  background: var(--blanco);
  color: var(--grisOscuro);

  &:focus {
    outline: none;
    border-color: var(--violeta);
  }

  &::placeholder {
    color: var(--grisMedio);
  }
`;

export const SelectorMes = styled.input`
  flex: 0 0 auto;
  padding: 0.6rem 0.75rem;
  font-family: inherit;
  font-size: 0.95rem;
  border: 1px solid #d8d2e6;
  border-radius: var(--radio);
  background: var(--blanco);
  color: var(--grisOscuro);

  &:focus {
    outline: none;
    border-color: var(--violeta);
  }
`;

// Línea de total: "Octubre 2026 · 63 ventas" o "12 resultados para «perez»".
export const TotalLinea = styled.p`
  margin: 0 0 0.75rem;
  font-size: 0.9rem;
  color: var(--grisMedio);

  strong {
    color: var(--violetaOscuro);
  }
`;

// Botón "Pasar a venta" en cada solicitud (lleva los datos al formulario).
export const BotonVenta = styled.button`
  padding: 0.4rem 0.9rem;
  font-family: inherit;
  font-size: 0.85rem;
  font-weight: 600;
  color: var(--blanco);
  background: var(--naranja);
  border: none;
  border-radius: var(--radio);
  cursor: pointer;
  white-space: nowrap;

  &:hover {
    filter: brightness(0.95);
  }
`;

// Marca de solicitud ya convertida en venta, con el N° de cliente.
export const ChipConvertida = styled.span`
  display: inline-block;
  font-size: 0.78rem;
  font-weight: 700;
  color: #1e7d4f;
  border: 1px solid #1e7d4f;
  border-radius: 999px;
  padding: 0.15rem 0.6rem;
  white-space: nowrap;
`;

// Toggle "ver convertidas" de la solapa de solicitudes.
export const ToggleConvertidas = styled.label`
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  margin: 0 0 0.75rem;
  font-size: 0.9rem;
  color: var(--grisMedio);
  cursor: pointer;

  input {
    cursor: pointer;
  }
`;

export const VerMas = styled.button`
  display: block;
  margin: 1rem auto 0;
  padding: 0.6rem 1.4rem;
  font-family: inherit;
  font-size: 0.9rem;
  font-weight: 600;
  color: var(--violetaOscuro);
  background: var(--blanco);
  border: 1px solid var(--violeta);
  border-radius: var(--radio);
  cursor: pointer;

  &:hover:not(:disabled) {
    background: #f3eefa;
  }

  &:disabled {
    opacity: 0.6;
    cursor: default;
  }
`;
